import { Tabs, Tab, Box } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { COLORS, LISTING_FILTER_WIDTH } from "constants/layout";

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  marginBottom: theme.spacing(1),
  width: LISTING_FILTER_WIDTH,
  minHeight: "unset",
  "& .MuiTab-root": {
    textTransform: "none",
    minWidth: 0,
    padding: theme.spacing(0.5, 2),
    minHeight: "unset",
    height: "32px",
    color: theme.palette.text.primary,
    flex: 1,
    "&.Mui-selected": {
      color: COLORS.green[600],
    },
  },
  "& .MuiTabs-indicator": {
    backgroundColor: COLORS.green[600],
  },
}));

const ListingTabs = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();

  // Check if current URL contains buyer or supplier
  const isBuyersPage = pathname.includes("buyer");
  const isSuppliersPage = pathname.includes("supplier");

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    const fullUrl = `${pathname}${search}`;
    
    if (newValue === "buyers" && !isBuyersPage) {
      // Switch to buyers - replace supplier with buyer
      const newPath = fullUrl.replace(/supplier/g, 'buyer');
      history.push(newPath);
    } else if (newValue === "suppliers" && !isSuppliersPage) {
      // Switch to suppliers - replace buyer with supplier  
      const newPath = fullUrl.replace(/buyer/g, 'supplier');
      history.push(newPath);
    }
  };

  return (
    <Box sx={{ width: LISTING_FILTER_WIDTH }}>
      <StyledTabs
        value={isBuyersPage ? "buyers" : "suppliers"}
        onChange={handleChange}
        aria-label="listing tabs"
        variant="fullWidth"
        sx={{ mb: 0 }}
      >
        <Tab label="Buyers" value="buyers" />
        <Tab label="Suppliers" value="suppliers" />
      </StyledTabs>
    </Box>
  );
};

export default ListingTabs;